import { useMutation } from "@tanstack/react-query";
import { apiUrls } from "src/consts/ApiUrls";
import { portalApiClient } from "../apiClient";
import { useAssignmentByInspectionId } from "src/api/hooks/useAssignment";

export default function useAssignmentMutation() {
  const { invalidate } = useAssignmentByInspectionId();
  const mutation = useMutation({
    mutationFn: async (assignment: any) => {
      if (assignment.id) {
        const response = await portalApiClient.put(
          apiUrls.assignment.create.url(),
          assignment
        );
        invalidate();
        return response?.data;
      }
      const response = await portalApiClient.post(
        apiUrls.assignment.create.url(),
        assignment
      );
      invalidate();
      return response?.data;
    },
  });
  return mutation;
}
